import ShareContent from './ShareContent';
export default ShareContent;